export default class Office{
    constructor(_id=null,name='',address='',location=Array,managers=Array){
        this._id=_id;
        this.name=name;
        this.address=address;
        this.location=location;
        this.managers=managers;

    }
}